import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function PainAgitation() {
  return <section className="px-6 py-4 max-w-3xl mx-auto" data-id="element-425">
      <FadeIn data-id="element-426">
        <div className="space-y-5 text-lg md:text-xl leading-relaxed text-[#2D2A26]" data-id="element-427">
          <p className="font-bold text-2xl text-[#4A5D3A]" data-id="element-428">
            No es un problema de carácter. Es biología. Y la biología tiene
            solución.
          </p>

          <p data-id="element-429">Por eso cuando por fin te acuestas:</p>

          <p data-id="element-430">Tu cuerpo está cansado… pero tu mente sigue acelerada.</p>

          <p data-id="element-431">Tu cerebro aún cree que hay una amenaza.</p>

          <p className="font-bold text-[#4A5D3A]" data-id="element-432">
            Y aquí es donde las plantas correctas, preparadas de la forma
            correcta, pueden ayudar a tu sistema nervioso a bajar la intensidad.
          </p>
          <FadeIn data-id="element-433">
            <p className="text-sm md:text-base text-[#9B4F2B] mb-8 font-medium tracking-wide" data-id="element-434">
              El problema nunca fue la planta. Es cómo la preparas.
            </p>
          </FadeIn>

          <img src="https://cdn.magicpatterns.com/uploads/bgv1Piodsfy75vDXNLvHYy/en_vez_del_cerebro.png" alt="Rescate Botánico — guía digital en tablet y móvil" className="w-full max-w-md mx-auto rounded-2xl shadow-lg mt-6" data-id="element-435" />
          <p className="text-sm md:text-base italic text-[#9B4F2B] mb-6 font-medium tracking-wide" data-id="element-436">
            Esto es lo que recibirás al acceder al método:
          </p>
          <p className="text-sm md:text-base italic text-[#4A5D3A] mb-6 font-medium tracking-wide" data-id="element-437">
            • El protocolo botánico de 15 minutos
          </p>
          <p className="text-sm md:text-base italic text-[#4A5D3A] mb-6 font-medium tracking-wide" data-id="element-438">
            • Las combinaciones exactas de plantas
          </p>
          <p className="text-sm md:text-base italic text-[#4A5D3A] mb-6 font-medium tracking-wide" data-id="element-439">
            • Recetas paso a paso para calmar tu sistema nervioso
          </p>
          <p className="text-sm md:text-base italic text-[#4A5D3A] mb-6 font-medium tracking-wide" data-id="element-440">
            • Preparaciones simples que puedes hacer con plantas que consigues
            fácilmente
          </p>

          <p className="font-bold text-[#4A5D3A]" data-id="element-441">
            Acceso inmediato desde tu Celular o Tablet o Laptop.
          </p>
        </div>
      </FadeIn>
    </section>;
}